import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-white text-stone-500 border-t border-stone-200">
    <div className="max-w-screen-xl mx-auto px-6 lg:px-10 pt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-stone-200">

        {/* Brand */}
        <div>
          <img
            src="https://storage.readdy-site.link/project_files/058bf520-f657-4c96-b118-7a4d18744205/4d9bb29b-3793-4492-b8d6-4116ced28368_polish-concrete.png?v=8f2e6b7e812c1f7d87b3da2c1fdb6bff"
            alt="Polished Concrete Plus"
            className="h-14 w-auto mb-5"
          />
          <p className="text-sm leading-relaxed text-stone-400 mb-6">
            Minnesota's premier installer of polished concrete and decorative surface finishes since 2003.
            Serving MN, IA, WI, ND &amp; SD.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com/profile.php?id=100054372737737"
              target="_blank"
              rel="nofollow noopener"
              className="w-9 h-9 flex items-center justify-center border border-stone-300 text-stone-500 hover:border-[#c8a951] hover:text-[#c8a951] transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-sm" />
            </a>
            <a
              href="https://www.instagram.com/polishedconcreteplus/"
              target="_blank"
              rel="nofollow noopener"
              className="w-9 h-9 flex items-center justify-center border border-stone-300 text-stone-500 hover:border-[#c8a951] hover:text-[#c8a951] transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 id="footer-nav" className="text-stone-800 text-xs uppercase tracking-[0.22em] font-semibold mb-6">
            <a href="#footer-nav">Quick Links</a>
          </h4>
          <ul className="space-y-3">
            {[
              { label: 'Home', to: '/' },
              { label: 'Services', to: '/services' },
              { label: 'About Us', to: '/about' },
              { label: 'Locations', to: '/location' },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm hover:text-[#c8a951] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 id="footer-services" className="text-stone-800 text-xs uppercase tracking-[0.22em] font-semibold mb-6">
            <a href="#footer-services">Our Services</a>
          </h4>
          <ul className="space-y-3 text-sm">
            {['Polished Concrete', 'Concrete Restoration', 'Floor Coatings', 'Custom Graphics & Logos', 'Terrazzo', 'Resurfacing'].map((s) => (
              <li key={s}>
                <Link to="/services" className="hover:text-[#c8a951] transition-colors">{s}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 id="footer-contact" className="text-stone-800 text-xs uppercase tracking-[0.22em] font-semibold mb-6">
            <a href="#footer-contact">Contact Us</a>
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-map-pin-2-line text-[#c8a951]" />
              </div>
              <span>15076 15th Ave NW<br />Rice, MN 56367</span>
            </li>
            <li className="flex gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-phone-line text-[#c8a951]" />
              </div>
              <a href="tel:3204931454" className="hover:text-[#c8a951] transition-colors">320.493.1454</a>
            </li>
            <li className="flex gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-mail-line text-[#c8a951]" />
              </div>
              <a href="mailto:josh@polishedconcreteplus.com" className="hover:text-[#c8a951] transition-colors break-all text-xs">
                josh@polishedconcreteplus.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center gap-3 pt-8 text-xs text-stone-400">
        <p>&copy; 2026 Polished Concrete Plus &mdash; All Rights Reserved.</p>
        <p>Rice, MN &middot; Serving Minnesota &amp; Surrounding States</p>
      </div>
    </div>
  </footer>
);

export default Footer;
